export const TRAVEL_SOUND = "/sounds/Travel01.mp3";

export const playTravelSound = (): void => {
  const audio = new Audio(TRAVEL_SOUND);
  audio.volume = 0.55;
  void audio.play().catch(() => undefined);
};
